<template>
  <main>
    <div class="row">
      <div class="col-12">
        <div class="tile">
          <div class="form-inline">
            <b-form-input class="mr-1 mb-1" v-model="filterFormModel.keyword" v-on:keydown.enter="load"
                          :placeholder="$t('keyword')"></b-form-input>
            <b-form-select class="mr-1 mb-1" v-model="filterFormModel.status" @change="load">
              <option :value="undefined">{{ $t('all') }}</option>
              <option value="0">{{ $t('partnerDomain.enabled') }}</option>
              <option value="1">{{ $t('partnerDomain.disabled') }}</option>
            </b-form-select>
            <button @click="load" class="btn btn-primary mr-1 mb-1">{{ $t('search') }}</button>
            <button @click="reset" class="btn btn-secondary mr-1 mb-1">Reset</button>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="c-sorting" v-if="canWrite">
          <div class="row">
            <div class="col-lg-12 c-sorting__right">
              <div class="c-sorting__btn">
                <button @click="create" class="btn btn-sm btn-success">
                  <font-awesome-icon icon="plus"/>&nbsp;{{ $t('create') }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="c-paging clearfix">
          <div class="c-paging__count" v-if="itemCount">{{ $t('found', [itemCount]) }}</div>
          <div class="c-paging__right">
            <div class="c-paging__numbers">
              <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                            v-model="filterFormModel.page" :total-rows="itemCount"
                            :per-page="filterFormModel.pageSize" @input="load"></b-pagination>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12" v-if="items.length">
        <div class="c-smart-table tile">
          <div class="row c-smart-table__title">
            <div class="col-lg-3">{{ $t('partnerDomain.colDomain') }}</div>
            <div class="col-lg-2">{{ $t('partnerDomain.agency') }}</div>
            <div class="col-lg-1 text-center">{{ $t('partnerDomain.clientCount') }}</div>
            <div class="col-lg-2 text-center">{{ $t('partnerDomain.colTheme') }}</div>
            <div class="col-lg-2 text-center">{{ $t('status') }}</div>
            <div class="col-lg-2"></div>
          </div>
          <div class="row align-items-center pd-row" v-for="item in items" :key="item._id">
            <!-- Logo + tên + domain -->
            <div class="col-lg-3 d-flex align-items-center">
              <img v-if="item.branding && item.branding.logo" :src="item.branding.logo" alt="logo"
                   style="height:34px;width:auto;max-width:60px;object-fit:contain;margin-right:10px"/>
              <font-awesome-icon v-else icon="globe" class="text-muted mr-2" size="lg"/>
              <div>
                <div><b>{{ item.name }}</b></div>
                <a :href="'https://' + item.domain" target="_blank" class="small">{{ item.domain }}</a>
              </div>
            </div>
            <!-- Tài khoản đối tác -->
            <div class="col-lg-2">
              <span v-if="item.agency"><font-awesome-icon icon="user-tie" class="text-info"/> {{ item.agency.name }}</span>
              <span v-else class="text-danger small"><font-awesome-icon icon="exclamation-triangle"/> {{ $t('partnerDomain.noAgency') }}</span>
            </div>
            <!-- Số khách hàng -->
            <div class="col-lg-1 text-center">
              <span class="badge badge-info" style="font-size:13px;padding:5px 9px">
                <font-awesome-icon icon="users"/> {{ item.clientCount || 0 }}
              </span>
            </div>
            <!-- Preview giao diện: title + dải màu ngang -->
            <div class="col-lg-2 text-center">
              <div v-if="item.branding && item.branding.title" class="small text-secondary text-truncate" :title="item.branding.title">{{ item.branding.title }}</div>
              <div class="d-flex justify-content-center" style="gap:4px;flex-wrap:wrap;margin-top:3px">
                <span v-for="c in activeColors(item)" :key="c" :title="item.branding[c]"
                      :style="{ width:'16px', height:'16px', borderRadius:'3px', border:'1px solid #ccc', background:item.branding[c] }"></span>
                <span v-if="!activeColors(item).length" class="small text-muted">—</span>
              </div>
            </div>
            <!-- Trạng thái -->
            <div class="col-lg-2 text-center">
              <span class="badge" :class="item.enabled ? 'badge-success' : 'badge-secondary'">
                {{ item.enabled ? $t('partnerDomain.enabled') : $t('partnerDomain.disabled') }}
              </span>
            </div>
            <!-- Hành động -->
            <div class="col-lg-2 d-flex justify-content-end align-items-center" v-if="canWrite">
              <button @click="update(item._id)" type="button" class="btn btn-sm btn-info" :title="$t('edit')">
                <font-awesome-icon icon="edit"/>
              </button>
              <button @click="del(item._id)" type="button" v-if="canDelete" class="btn btn-sm btn-danger ml-1" :title="$t('delete')">
                <font-awesome-icon icon="trash"/>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 text-center text-danger" v-if="!items.length && !listLoading">
        <span>{{ $t('notFoundSearch') }}</span>
      </div>
    </div>

    <b-modal v-model="showForm" size="lg" :title="formTitle" @ok="onSave" no-close-on-backdrop no-enforce-focus>
      <div class="pd-form">

        <!-- KHU VỰC 1: Thông tin chung -->
        <div class="pd-section">
          <div class="pd-section__title"><font-awesome-icon icon="globe"/> {{ $t('partnerDomain.secGeneral') }}</div>
          <form-input :label="$t('partnerDomain.domainLabel')" :model="formModel" attribute="domain"
                      :errors="formErrors" placeholder="crm.doitac.com"></form-input>
          <form-input :label="$t('partnerDomain.name')" :model="formModel" attribute="name"
                      :errors="formErrors"></form-input>
          <admin-user-select :model="formModel" attribute="agency" roleFilter="agency"
                             :label="$t('partnerDomain.agency') + ' *'" :place-holder="$t('partnerDomain.chooseAgency')"
                             :errors="formErrors"></admin-user-select>
          <form-checkbox :chk-label="$t('partnerDomain.enabled')" :model="formModel" attribute="enabled"
                         :errors="formErrors"></form-checkbox>
        </div>

        <!-- KHU VỰC 2: Nhận diện thương hiệu (logo/favicon/tiêu đề) -->
        <div class="pd-section">
          <div class="pd-section__title"><font-awesome-icon icon="image"/> {{ $t('partnerDomain.secBrand') }}</div>
          <form-input :label="$t('partnerDomain.titleField')" :model="formModel.branding" attribute="title"
                      :errors="formErrors"></form-input>
          <b-form-group :label="'Logo'">
            <div class="d-flex align-items-center">
              <img v-if="formModel.branding.logo" :src="formModel.branding.logo" alt="logo"
                   style="max-height:40px;margin-right:8px"/>
              <b-form-file accept="image/png,image/jpeg,image/jpg" :placeholder="$t('partnerDomain.choosePngJpg')"
                           @input="file => uploadAsset(file, 'logo')"></b-form-file>
              <button v-if="formModel.branding.logo" type="button" class="btn btn-sm btn-link text-danger"
                      @click="formModel.branding.logo = ''">{{ $t('partnerDomain.clear') }}</button>
            </div>
          </b-form-group>
          <b-form-group :label="'Favicon'">
            <div class="d-flex align-items-center">
              <img v-if="formModel.branding.favicon" :src="formModel.branding.favicon" alt="favicon"
                   style="max-height:24px;margin-right:8px"/>
              <b-form-file accept="image/png,image/jpeg,image/jpg" :placeholder="$t('partnerDomain.choosePngJpg')"
                           @input="file => uploadAsset(file, 'favicon')"></b-form-file>
              <button v-if="formModel.branding.favicon" type="button" class="btn btn-sm btn-link text-danger"
                      @click="formModel.branding.favicon = ''">{{ $t('partnerDomain.clear') }}</button>
            </div>
          </b-form-group>
        </div>

        <!-- KHU VỰC 3: Trang đăng nhập (banner + slogan) -->
        <div class="pd-section">
          <div class="pd-section__title"><font-awesome-icon icon="sign-in-alt"/> {{ $t('partnerDomain.secLogin') }}</div>
          <b-form-group :label="$t('partnerDomain.loginBanner')" :description="$t('partnerDomain.loginBannerDesc')">
            <div class="d-flex align-items-center">
              <img v-if="formModel.branding.loginBanner" :src="formModel.branding.loginBanner" alt="banner"
                   style="max-height:60px;margin-right:8px"/>
              <b-form-file accept="image/png,image/jpeg,image/jpg" :placeholder="$t('partnerDomain.choosePngJpg')"
                           @input="file => uploadAsset(file, 'loginBanner', 3)"></b-form-file>
              <button v-if="formModel.branding.loginBanner" type="button" class="btn btn-sm btn-link text-danger"
                      @click="formModel.branding.loginBanner = ''">{{ $t('partnerDomain.clear') }}</button>
            </div>
          </b-form-group>
          <b-form-group :label="$t('partnerDomain.loginSlogan')" :description="$t('partnerDomain.loginSloganDesc')">
            <b-form-textarea v-model="formModel.branding.loginSlogan" rows="2" max-rows="4"
                             :placeholder="sloganPlaceholder"></b-form-textarea>
          </b-form-group>
        </div>

        <!-- KHU VỰC 4: Màu sắc giao diện dashboard -->
        <div class="pd-section">
          <div class="pd-section__title"><font-awesome-icon icon="palette"/> {{ $t('partnerDomain.secColors') }}</div>
          <div class="row">
            <div class="col-md-6" v-for="c in colorFields" :key="c">
              <b-form-group :label="$t('partnerDomain.' + c)">
                <div class="d-flex align-items-center">
                  <input type="color" :value="formModel.branding[c] || '#000000'"
                         @input="e => formModel.branding[c] = e.target.value" style="width:42px;height:32px;margin-right:8px"/>
                  <b-form-input v-model="formModel.branding[c]" placeholder="#RRGGBB" style="max-width:120px"></b-form-input>
                  <button v-if="formModel.branding[c]" type="button" class="btn btn-sm btn-link text-danger"
                          @click="formModel.branding[c] = ''">{{ $t('partnerDomain.clear') }}</button>
                </div>
              </b-form-group>
            </div>
          </div>
        </div>

      </div>
    </b-modal>
  </main>
</template>

<script>
import List from '../../mixins/List';
import CRUD from "../../mixins/CRUD";
import AdminUserSelect from "@/components/AdminUserSelect";

function emptyBranding() {
  return { logo: '', favicon: '', primaryColor: '', secondaryColor: '', sidebarBgColor: '', headerBgColor: '', title: '', loginBanner: '', loginSlogan: '' };
}

export default {
  components: { AdminUserSelect },
  mixins: [List, CRUD],
  data: function () {
    return {
      service: '/partner-domain',
      autoLoad: true,
      sloganPlaceholder: 'Phần mềm quản lý kinh doanh tập trung\nThúc đẩy tăng trưởng thật',
      colorFields: ['primaryColor', 'secondaryColor', 'sidebarBgColor', 'headerBgColor'],
      defaultFormModel: {
        domain: null,
        name: null,
        agency: null,
        enabled: true,
        branding: emptyBranding()
      }
    }
  },
  computed: {
    canWrite() {
      return ['owner', 'admin'].includes(this.$store.state.user.role);
    },
    canDelete() {
      return ['owner'].includes(this.$store.state.user.role);
    }
  },
  i18n: {
    messages: {
      en: {
        all: 'All', status: 'Status',
        partnerDomain: {
          title: 'Partner domains', domain: 'Domain', domainLabel: 'Domain (FQDN)', name: 'Partner name',
          titleField: 'Display title', colors: 'Colors', enabled: 'Enabled', disabled: 'Disabled',
          clear: 'Clear', choosePngJpg: 'PNG/JPG only',
          secGeneral: 'General', secBrand: 'Brand identity', secLogin: 'Login page (white-label)', secColors: 'Dashboard colors',
          agency: 'Partner account', chooseAgency: 'Choose partner account', noAgency: 'No partner account',
          agencyRequired: 'Please choose a partner account (required)',
          colDomain: 'Partner / Domain', colTheme: 'Theme', clientCount: 'Customers',
          loginBanner: 'Login banner image', loginBannerDesc: 'Right-side image on login/forgot/register (PNG/JPG, ≤3MB)',
          loginSlogan: 'Login slogan', loginSloganDesc: 'Intro text under banner. Each line = one row.',
          primaryColor: 'Primary color', secondaryColor: 'Secondary color',
          sidebarBgColor: 'Sidebar background', headerBgColor: 'Header background'
        }
      },
      vi: {
        all: 'Tất cả', status: 'Trạng thái',
        partnerDomain: {
          title: 'Domain đối tác', domain: 'Domain', domainLabel: 'Domain (FQDN)', name: 'Tên đối tác',
          titleField: 'Tiêu đề hiển thị', colors: 'Màu sắc', enabled: 'Đang bật', disabled: 'Đang tắt',
          clear: 'Bỏ', choosePngJpg: 'Chỉ PNG/JPG',
          secGeneral: 'Thông tin chung', secBrand: 'Nhận diện thương hiệu', secLogin: 'Trang đăng nhập (white-label)', secColors: 'Màu sắc dashboard',
          agency: 'Tài khoản đối tác', chooseAgency: 'Chọn tài khoản đối tác', noAgency: 'Chưa gắn tài khoản',
          agencyRequired: 'Vui lòng chọn Tài khoản đối tác (bắt buộc)',
          colDomain: 'Đối tác / Domain', colTheme: 'Giao diện', clientCount: 'Khách hàng',
          loginBanner: 'Ảnh banner trang đăng nhập', loginBannerDesc: 'Ảnh cột phải trang login/forgot/register (PNG/JPG, ≤3MB)',
          loginSlogan: 'Câu giới thiệu', loginSloganDesc: 'Chữ dưới banner. Mỗi dòng = một hàng.',
          primaryColor: 'Màu chính', secondaryColor: 'Màu phụ',
          sidebarBgColor: 'Nền sidebar', headerBgColor: 'Nền header'
        }
      }
    }
  },
  methods: {
    // Bắt buộc chọn Tài khoản đối tác trước khi lưu (giữ modal mở nếu thiếu)
    onSave: function (evt) {
      if (!this.formModel.agency) {
        if (evt) evt.preventDefault();
        this.$swal({ text: this.$t('partnerDomain.agencyRequired'), icon: 'error' });
        return;
      }
      this.save(evt); // save() của mixin CRUD
    },
    // Trả danh sách màu đã set (tránh v-for+v-if trên cùng element)
    activeColors: function (item) {
      if (!item || !item.branding) return [];
      return this.colorFields.filter(c => item.branding[c]);
    },
    load: function () {
      let loader = this.$loading.show();
      this.listLoading = true;
      this.$service.get(this.service, { params: this.filterFormModel }).then(response => {
        this.apply(response.data);
      }).catch(error => {
        if (error.response && error.response.data && error.response.data.message) {
          this.$swal({ text: error.response.data.message, icon: 'error' });
        }
      }).finally(() => {
        loader.hide();
        this.listLoading = false;
      });
    },
    create: function () {
      // Override để branding luôn là object MỚI (tránh share reference giữa các lần tạo)
      this.formModel = {
        domain: null,
        name: null,
        agency: null,
        enabled: true,
        branding: emptyBranding()
      };
      this.formTitle = this.$t('create');
      this.formErrors = [];
      this.showForm = true;
    },
    update: function (id) {
      let loader = this.$loading.show();
      this.$service.get(this.service + '/' + id).then(response => {
        let data = response.data || {};
        // Đảm bảo branding tồn tại đủ field cho data cũ
        data.branding = Object.assign(emptyBranding(), data.branding || {});
        this.formModel = data;
        this.formModel.id = id;
        this.formTitle = this.$t('update');
        this.formErrors = [];
        this.showForm = true;
      }).finally(() => { loader.hide(); });
    },
    uploadAsset: function (file, field, maxMb) {
      if (!file) return;
      maxMb = maxMb || 2;
      if (file.size / (1024 * 1024) > maxMb) {
        this.$swal({ text: this.$t('partnerDomain.choosePngJpg') + ' (≤ ' + maxMb + 'MB)', icon: 'error' });
        return;
      }
      let loader = this.$loading.show();
      const formData = new FormData();
      formData.append('file', file);
      this.$service.post('/upload/upload-image', formData).then(response => {
        const arr = response.data;
        if (Array.isArray(arr) && arr.length && arr[0].url) {
          this.$set(this.formModel.branding, field, arr[0].url);
        }
      }).catch(error => {
        const msg = error.response && error.response.data && error.response.data.message;
        this.$swal({ text: msg || 'Upload failed', icon: 'error' });
      }).finally(() => { loader.hide(); });
    }
  }
};
</script>

<style scoped>
.pd-form .pd-section {
  border: 1px solid #ececec;
  border-radius: 8px;
  padding: 16px 16px 4px;
  margin-bottom: 18px;
  background: #fcfcfd;
}
.pd-form .pd-section__title {
  font-weight: 700;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: .04em;
  color: #6c5ce7;
  margin: -4px 0 14px;
  padding-bottom: 8px;
  border-bottom: 1px solid #eee;
}
.pd-form .pd-section__title svg { margin-right: 6px; }
</style>
